module.exports = "<div class=ui-grid-cell-contents> <div ng-if=\"row.entity.is_editable === 1\" style=text-align:left!important> <a class=\"text-xs m-r-md\" ui-sref=\"generalSettings.editSubject({subjectId: row.entity.subject_code})\"> <i class=\"icon mdi-editor-border-color i-16 dark-icon m-r-xs\"></i> Editar </a> <a ng-if=\"row.entity.subject_status === 1\" class=\"text-xs m-r-md\" ng-click=grid.appScope.subjectListVM.confirmDisableSubject(row)> <i class=\"icon mdi-action-delete i-16 dark-icon m-r-xs\"></i> Desactivar </a> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/generalSettings/subjects/list/listSubjectCell.html
// module id = 287
// module chunks = 0